import { Image as KonvaImage, Layer, Stage, Transformer } from 'react-konva';
import React, { useCallback, useRef, useState } from "react";
import { Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

import giletify from './assets/giletify.png'
import bobFull from './assets/bob_full.png'
import bobHead from './assets/bob_head.png'
import gilet from './assets/gilet.png'

import './App.css';

function App() {
  const [image, setImage] = useState(null);
  const [canvasHeight, setCanvasHeight] = useState(600);
  const [canvasWidth, setCanvasWidth] = useState(600);
  const [overlayImage, setOverlayImage] = useState(new Image())

  const [isExportable, setIsExportable] = useState(false);

  const stageRef = useRef(null);
  const transformerRef = useRef(null);
  const fileInputRef = React.useRef(null);

  // overlayImage.src = bobFull;

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Programmatically triggers the file input dialog
  };

  const onImportImageSelect = useCallback((e) => {
    if (e.target.files?.[0]) {
      const imageUrl = URL.createObjectURL(e.target.files?.[0]);
      const image = new Image();
      image.src = imageUrl;
      image.onload = function () {
        const aspectRatio = image.width / image.height;

        let newCanvasWidth = 600;
        let newCanvasHeight = 600 / aspectRatio;

        if (newCanvasHeight > 600) {
          newCanvasHeight = 600;
          newCanvasWidth = 600 * aspectRatio;
        }

        setCanvasWidth(newCanvasWidth);
        setCanvasHeight(newCanvasHeight);

        setIsExportable(true);
      }

      setImage(image);
    }
    e.target.files = null;
  },
    []
  );

  const onExportClick = useCallback(() => {
    if (transformerRef.current) {
      transformerRef.current.visible(false);
    }
  
    const dataUri = stageRef.current.toDataURL({ pixelRatio: 3 });  

    if (transformerRef.current) {
      transformerRef.current.visible(true);
    }
    downloadURI(dataUri, "image.png");
  }, []);

  const downloadURI = (uri, name) => {
    const link = document.createElement("a");
    link.download = name;
    link.href = uri || "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onImageClick = useCallback((e) => {
    const currentTarget = e.currentTarget;
    transformerRef?.current?.node(currentTarget);
  },
    []
  );

  const changeOverlayImage = (e) => {
    const image = new Image();
    image.src = e.currentTarget.src;
    setOverlayImage(image)        
  };

  const resetCanvas = () => {
    setImage(null)
    setIsExportable(false)
    setCanvasWidth(600);
    setCanvasHeight(600);
  };

  return (
    // Stage - is a div wrapper
    // Layer - is an actual 2d canvas element, so you can have several layers inside the stage
    // Rect and Circle are not DOM elements. They are 2d shapes on canvas
    <div className='container' height>
      <a href="https://linktr.ee/tradfibrocfa">
        <img src={giletify} style={{marginTop: '40px'}} />
      </a>

      <h6 className='sub-title'>Choose your item and upload image to edit</h6>

      <div style={{ margin: '15px' }}>
        <Row style={{ display: 'flex' }}>
          <Col><button style={{ cursor: 'pointer', background: 'none', border: 'none' }}><img width={50} height={70} src={bobFull} onClick={changeOverlayImage} /></button></Col>
          <Col><button style={{ cursor: 'pointer', background: 'none', border: 'none' }}><img width={50} height={60} src={bobHead} onClick={changeOverlayImage} /></button></Col>
          <Col><button style={{ cursor: 'pointer', background: 'none', border: 'none' }}><img width={50} height={70} src={gilet} onClick={changeOverlayImage} /></button></Col>
        </Row>
      </div>

      <div className='canvas-container'>
        <Stage width={canvasWidth} height={canvasHeight} ref={stageRef}>
          <Layer>
            {image && (
              <KonvaImage
                image={image}
                height={canvasHeight}
                width={canvasWidth}
                draggable={false}
              />
            )}
            {overlayImage && (
              <KonvaImage
                image={overlayImage}
                x={200}
                y={200}
                height={250}
                width={200}
                draggable={true}
                onClick={onImageClick}
              />
            )}
            <Transformer ref={transformerRef} />
          </Layer>
        </Stage>
      </div>

      <div style={{ display: 'flex', 'margin-top': '10px' }}>
        {isExportable ?
          <div>
            <Button variant='danger' style={{marginRight: '10px'}} onClick={resetCanvas}>Clear</Button>
            <Button onClick={onExportClick}>Export</Button>
          </div>
          :
          <div>
            <input
              type="file"
              ref={fileInputRef}
              onChange={onImportImageSelect}
              accept="image/*"
              style={{ display: 'none' }} // Hides the input
            />
            <Button variant="primary" onClick={handleButtonClick}>
              Upload Image
            </Button>
          </div>
        }
      </div>
    </div>
  );
}

export default App;
